var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 36,
    height: 36,
    rx: 14,
    transform: "rotate(90 36 0)",
    fill: "#03F5AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.002 24L22 20.0106L18.9995 20.0106L18.9995 13L17.0005 13L17.0005 20.0106L14 20.0106L18.002 24Z",
    fill: "#080715"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrow);
export default __webpack_public_path__ + "static/media/ic_arrow.21c34c0d9961fcd857ad1615013bbbb1.svg";
export { ForwardRef as ReactComponent };